import React, {Component} from 'react';
import {Card, CardBody, Col} from 'reactstrap';
import {Field, reduxForm} from 'redux-form';
import renderDropZoneField from '../../../shared/components/form/DropZone';
import {withTranslation} from "react-i18next";

class MainImageCard extends Component {

    render() {

        const {t} = this.props;

        return (
            <Col>
                <Card className="card--not-full-height">
                    <CardBody>
                        <div className="card__title">
                            <h5 className="bold-text">{t('settings.main_image.title')}</h5>
                            <h5 className="subhead">{t('settings.main_image.subtitle')}</h5>
                        </div>
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <Field
                                    name="main_image"
                                    component={renderDropZoneField}
                                    customHeight={true}
                                />
                            </div>
                        </div>
                        <h5 className="subhead">{t('settings.main_image.description')}</h5>

                    </CardBody>
                </Card>
            </Col>
        )

    }

}

export default reduxForm({
    form: 'blog_settings'
})(withTranslation('dashboard')(MainImageCard));
